import Type from "@/model/types/Type";

const type = {
    RESTRICT: 1,
    PUBLIC: 2,
}

const list = [
    {
        value: type.RESTRICT,
        text: "Restrito",

    },
    {
        value: type.PUBLIC,
        text: "Público",
        class:'text-danger'
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}